import React, {useEffect, useState} from "react";
import ProjectMember from "../../Components/ProjectEdit/ProjectMember";
import WINWorker from "../../Services/WINWorker";
import SalesContact from "../../Components/ProfileEdit/SalesContact";

export default function CompanyProfile() {

    const [companyEmployees, setCompanyEmployees] = useState([]);
    const company = window.company_id;
    let initCompanyEmployees = () => {
        WINWorker.getCompanyEmployees(company)
            .then(response => {
                console.log('response', response);
                setCompanyEmployees(response)
            })
            .catch(error => {
                console.log('error', error);
            });
    }

    useEffect(
        () => {
            initCompanyEmployees();
        },
        []
    );


    return (
        <React.Fragment>
            <SalesContact member_type_label={'Sales Contact'} members={companyEmployees}
                           member_involvement_type={'Sales Contact'}/>
        </React.Fragment>
    );

}
